import { action, computed, makeAutoObservable, observable, reaction } from 'mobx';
import { ApiReq, emptyValue } from 'src/api';
import { AssetsApi } from 'src/api/assets';
import { ActivityDashboardData } from 'src/types';

export class ActivityDashboardStore {
  api = new AssetsApi({ prefix: '' });

  @observable.ref dataReq: ApiReq<ActivityDashboardData> = emptyValue;
  @observable open: boolean = true;

  constructor() {
    makeAutoObservable(this);
    reaction(
      () => [this.open],
      () => {
        if (!this.open) {
          return;
        }
        this.loadData();
      },
    );
  }

  @action loadData = () => {
    this.dataReq = this.api.getDashboardData();
  };

  @action toggleOpen = () => {
    this.open = !this.open;
  };

  @computed
  get data() {
    if (this.dataReq.state !== 'fulfilled' || !this.dataReq.value) {
      return null;
    }

    return this.dataReq.value.data;
  }
}

